import { useEffect, useState } from "react";

import cropr from "../utils/cropr";

function useCachedUrlData<ResponseT>(url: string): { data?: ResponseT; error: any } {
  const [data, setData] = useState<ResponseT>();
  const [error, setError] = useState<any>();

  useEffect(
    () => {
      url &&
        cropr.cachedUrlGet(url, {
          success: (response) => setData(response),
          error: (error) => setError(error),
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [url]
  );

  return { data, error };
}

export default useCachedUrlData;
